import React from "react";
import { Reveal, SectionHeading } from "@/components/common/Reveal";
import { useEnquiryForm } from "@/context/FormContext";
import { Rocket, Landmark, Building2, ArrowUpRight } from "lucide-react";

const CARDS = [
  { icon: Rocket, label: "I am building an AI business", desc: "Apply for funding readiness, technology, marketing, manufacturing, distribution and growth support.", cta: "Apply for Capital & Growth Support", type: "founder" },
  { icon: Landmark, label: "I am exploring financial products", desc: "Request a private consultation concerning selected AIFs, PMS strategies, mutual funds, bonds, fixed-income products, insurance and other approved products.", cta: "Request an Investment Consultation", type: "investment" },
  { icon: Building2, label: "I represent a strategic organisation", desc: "Partner with FundAI through technology, manufacturing, capital, marketing, professional services, research or distribution capabilities.", cta: "Become a Strategic Partner", type: "partner" },
];

export default function ChoosePath() {
  const { openForm } = useEnquiryForm();
  return (
    <section id="choose" className="relative py-24 md:py-32 border-t border-white/5" data-testid="choose-path-section">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <Reveal><SectionHeading label="Choose Your Path" title="One platform. Three distinct journeys." className="max-w-3xl" /></Reveal>
        <div className="mt-14 grid lg:grid-cols-3 gap-5">
          {CARDS.map((c, i) => {
            const Icon = c.icon;
            return (
              <Reveal key={c.type} delay={i * 0.08}>
                <div className="card-hover h-full flex flex-col rounded-2xl border border-white/5 bg-[#0C0C10] p-8 hover:border-[#0057FF]/40 hover:-translate-y-1" data-testid={`choose-card-${c.type}`}>
                  <div className="flex h-12 w-12 items-center justify-center rounded-xl border border-white/10 bg-white/5 mb-6"><Icon className="h-5 w-5 text-[#00D1FF]" /></div>
                  <h3 className="font-head text-xl font-medium">{c.label}</h3>
                  <p className="mt-3 text-sm text-zinc-500 leading-relaxed flex-1">{c.desc}</p>
                  <button onClick={() => openForm(c.type)} className="group mt-6 inline-flex items-center gap-2 text-sm text-[#00D1FF] hover:text-white transition-colors" data-testid={`choose-cta-${c.type}`}>
                    {c.cta} <ArrowUpRight className="h-4 w-4 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform" />
                  </button>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
